import { Component, ViewChild, AfterViewInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Deal, DealsActionData } from '../../../clients/interface/data.interface';
import { MatTableDataSource } from '@angular/material/table';
import { ServiceInfoClientService } from '../../service/service-info-client.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ConfigRutService } from 'src/app/services/config-rut.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DetailDealComponent } from './detail-deal/detail-deal.component';
import { FilterPagination } from '../../interface/company-client.interface';
import { MatSort, Sort } from '@angular/material/sort';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';

@Component({
  selector: 'app-cmfdeals',
  templateUrl: './cmfdeals.component.html',
  styleUrls: ['./cmfdeals.component.scss']
})
export class CmfdealsComponent implements AfterViewInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator = Object.create(null);
  @Input() companyId: number;
  public dataDeal: DealsActionData;
  public pagedResult: any;
  public filterPagination: FilterPagination = {
    page: 1,
    pageSize: 5,
    sortColumn: '',
    sortOrder: ''
  };
  public load: boolean = false;
  public dataSource: MatTableDataSource<Deal> = new MatTableDataSource<Deal>([]);
  public displayedColumns: string[] = [
    'titulo',
    'finalidad',
    'nombreMandante',
    'ultimaFecha',
    'comision',
    'dealAmount',
    'position',
    'executiveName',
    'razonDealP'
  ];

  constructor(private infoService: ServiceInfoClientService, private configRutService: ConfigRutService, private dialog: MatDialog, private authService: AuthService) {

  }

  ngOnInit() {
    this.loadDeals();
  }

  ngAfterViewInit() {
    this.paginator = this.paginator;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataSource.data = this.pagedResult?.results ??[];
    this.paginator.length = this.pagedResult?.totalRows ?? 0;
    this.paginator.pageIndex = this.pagedResult?.currentPage -1 ?? 0;
    this.paginator.pageSize = this.pagedResult?.pageSize ?? 10;
  }

  public loadDeals(): Promise<any> {
    return new Promise((resolve, reject) => {
      var rut = this.configRutService.formatRutWithDv(this.companyId);
      const rutLimpio = rut.replace(/\./g, '').replace(/-/g, '');
      this.infoService.getDealsCompany(rutLimpio, this.filterPagination).subscribe({
        next: (response) => {
          this.pagedResult = response;
          this.dataSource.data = response.results;
          this.paginator.length = response?.totalRows ?? 0;
          this.paginator.pageIndex = response?.currentPage - 1 ?? 0;
          this.paginator.pageSize = response?.pageSize ?? 10;
          this.load = true;
          resolve(this.pagedResult); 
        },
        error: (err) => {
          console.log(err);
          reject(err); // Rechaza la promesa si hay un error
        }
      });
    });
  }

  public openModalDetaiDeals(data: any) {
    var emailUser = this.authService.getEmailIdentifier();
    this.dataDeal = {
      userId: emailUser,
      dealId: data.id,
      actions: data.actions
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '82vw';
    //dialogConfig.height = '76vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = this.dataDeal;

    var ref = this.dialog.open(DetailDealComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      this.loadDeals();
    });

    const instance = ref.componentInstance;
    instance.dealUpdated.subscribe((updated: boolean) => {
      if (updated) {
        this.loadDealsAndUpdateModal(instance);
      }
    });
  }

  public async loadDealsAndUpdateModal(modalInstance: DetailDealComponent) {
    try {
      await this.loadDeals(); // Espera que los tratos se carguen
      modalInstance.updateDeals(this.pagedResult); // Envía los tratos actualizados al modal
    } catch (error) {
      console.error("Error cargando los tratos:", error);
    }
  }

  public changePaginationTable(event: PageEvent) {
    /*this.filterPagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize,
    };*/
    this.filterPagination.page = event.pageIndex + 1;
    this.filterPagination.pageSize = event.pageSize;
    this.loadDeals();
  }

  public sortData(event: Sort) {
    const sortColumn = event.active; // Nombre de la columna seleccionada
    const sortOrder = event.direction; // 'asc' o 'decs
    this.filterPagination.sortOrder = sortOrder;
    this.filterPagination.sortColumn = sortColumn.charAt(0).toUpperCase() + sortColumn.slice(1);
    this.loadDeals();
  }

}
